import * as PIXI from 'pixi.js';
import {Ship} from '@game/ships/ship';
import {HullSize, ShipGameObject} from '@game/ships/ship.game-object';
import {ExhaustGameObject} from '@game/ships/parts/exhaust.game-object';
import {ShipCreateOptions} from '@game/ships/ship.factory';

export class TransporterBullockGameObject extends ShipGameObject {

  constructor(ship: Ship, opts: ShipCreateOptions) {
    super(ship, opts);

    // Center
    this.addExhaust(new ExhaustGameObject({
      track: this.ship,
      placement: 0,
      x: 2,
      y: 55,
      scale: 3,
      speed: 6,
    }));

    const res = PIXI.Loader.shared.resources;

    // @ts-ignore
    const sprite = new PIXI.Sprite(res.ships.textures['transporter_bullock.png']);
    this.addChild(sprite);
  }

  getSize(): number {
    return HullSize.Large;
  }
}
